import React from 'react';
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
interface BarChartProps {
  data: any[];
  nameKey: string;
  dataKey: string;
  fill?: string;
  horizontal?: boolean;
}
export const BarChart: React.FC<BarChartProps> = ({
  data,
  nameKey,
  dataKey,
  fill = '#2563eb',
  horizontal = false
}) => {
  if (horizontal) {
    return <ResponsiveContainer width="100%" height={40 * data.length} data-id="element-3">
        <RechartsBarChart data={data} layout="vertical" margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5
      }} data-id="element-4">
          <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} data-id="element-5" />
          <XAxis type="number" hide data-id="element-6" />
          <YAxis dataKey={nameKey} type="category" tick={{
          fontSize: 12
        }} tickLine={false} axisLine={false} width={150} data-id="element-7" />
          <Tooltip data-id="element-8" />
          <Bar dataKey={dataKey} fill={fill} barSize={12} radius={[6, 6, 6, 6]} data-id="element-9" />
        </RechartsBarChart>
      </ResponsiveContainer>;
  }
  return <ResponsiveContainer width="100%" height={300} data-id="element-10">
      <RechartsBarChart data={data} margin={{
      top: 10,
      right: 10,
      left: 0,
      bottom: 20
    }} data-id="element-11">
        <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-12" />
        <XAxis dataKey={nameKey} tick={{
        fontSize: 12
      }} tickLine={false} axisLine={{
        stroke: '#E5E7EB'
      }} data-id="element-13" />
        <YAxis tick={{
        fontSize: 12
      }} tickLine={false} axisLine={{
        stroke: '#E5E7EB'
      }} data-id="element-14" />
        <Tooltip data-id="element-15" />
        <Bar dataKey={dataKey} fill={fill} barSize={20} radius={[4, 4, 0, 0]} data-id="element-16" />
      </RechartsBarChart>
    </ResponsiveContainer>;
};